import { yupResolver } from '@hookform/resolvers/yup';
import { CustomButton } from '@Modules/core/components';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import { TFormUIProps } from '@Modules/core/types/FormUIPropsType';
import React from 'react';
import { useForm } from 'react-hook-form';
import CustomSaveBtn from '@Modules/core/components/form/CustomSaveBtn';
import { IRequestedCardFormMeta } from '@Modules/cardManagementSystem/debit/containers/formHandlers/holderManagement/debitApplication/requestedCard/formMeta/RequestedCardFormMeta';
import displayCustomInputs from '@Shared/utils/displayCustomInputs';
import CustomFieldSet from '@Modules/core/components/CustomFieldSet';
import { getFormFieldsName } from '@Shared/utils/getFormFieldsNames';
import holderDataFormMeta from '@Modules/cardManagementSystem/debit/containers/formHandlers/holderManagement/debitApplication/requestedCard/formMeta/HolderDataFormMeta';
import cardDataFormMeta from '@Modules/cardManagementSystem/debit/containers/formHandlers/holderManagement/debitApplication/requestedCard/formMeta/CardDataFormMeta';

type Props = {
  meta: IRequestedCardFormMeta,
} & TFormUIProps;

const RequestedCardFormUI: React.FC<Props> = ({
  onSubmit,
  isLoading,
  isSubmitting,
  meta,
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ resolver: yupResolver(meta.schema) });

  return (
    <CC.Box as={'form'} onSubmit={handleSubmit(onSubmit)}>
      <CustomFieldSet title={'Donnée Porteur'}>
        <CC.SimpleGrid
          columns={{ base: 1, lg: 3 }}
          gridRowGap={4}
          columnGap={10}
          my={4}
        >
          {displayCustomInputs<IRequestedCardFormMeta>(
            meta,
            register,
            errors,
            isLoading,
            [...getFormFieldsName(holderDataFormMeta)]
          )}
        </CC.SimpleGrid>
      </CustomFieldSet>

      <CustomFieldSet title={'Donnée Carte'}>
        <CC.SimpleGrid
          columns={{ base: 1, lg: 2 }}
          gridRowGap={4}
          columnGap={10}
          my={4}
        >
          {displayCustomInputs<IRequestedCardFormMeta>(
            meta,
            register,
            errors,
            isLoading,
            [...getFormFieldsName(cardDataFormMeta)],
            [
              meta.panGeneration.name,
              meta.pan.name,
              meta.primary_secondary.name,
              meta.primaryCard.name,
              meta.newCardDesign.name,
              meta.fastDelivery.name,
            ]
          )}
        </CC.SimpleGrid>

        <CC.Flex
          alignItems={'center'}
          direction={{ base: "column", lg: "row"}}
          columnGap={{lg: 10}}
          my={4}
          w={'100%'}
        >
          <CustomFieldSet title={'Génération PAN'} w={{base: "full", lg: '98%'}} my={"inherit"}>
            {displayCustomInputs<IRequestedCardFormMeta>(
              meta,
              register,
              errors,
              isLoading,
              [meta.panGeneration.name]
            )}
          </CustomFieldSet>
          {displayCustomInputs<IRequestedCardFormMeta>(
            meta,
            register,
            errors,
            isLoading,
            [meta.pan.name]
          )}
        </CC.Flex>

        <CC.Flex
          alignItems={'center'}
          direction={{ base: "column", lg: "row"}}
          columnGap={{lg: 10}}
          my={4}
          w={'100%'}
        >
          <CustomFieldSet title={''} w={{base: "full", lg: '98%'}}>
            {displayCustomInputs<IRequestedCardFormMeta>(
              meta,
              register,
              errors,
              isLoading,
              [meta.primary_secondary.name]
            )}
          </CustomFieldSet>
          {displayCustomInputs<IRequestedCardFormMeta>(
            meta,
            register,
            errors,
            isLoading,
            [meta.primaryCard.name]
          )}
        </CC.Flex>

        <CC.SimpleGrid
          columns={{ base: 1, lg: 2 }}
          gridRowGap={4}
          columnGap={10}
          my={4}
        >
          {displayCustomInputs<IRequestedCardFormMeta>(
            meta,
            register,
            errors,
            isLoading,
            [meta.newCardDesign.name, meta.fastDelivery.name]
          )}
        </CC.SimpleGrid>
      </CustomFieldSet>

      <CC.HStack my={4} justifyContent={'flex-end'}>
        <CustomSaveBtn isLoading={isLoading} isSubmitting={isSubmitting} />
      </CC.HStack>
    </CC.Box>
  );
};

export default RequestedCardFormUI;
